"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
const PROGRESS_WEIGHT = 1;
function getProgressWeightOfChildContent(content) {
    let totalContentProgressWeight = 0;
    content.children.forEach((childContent) => {
        const isChildValidForProgressMeasure = childContent.contributeToCompleteStatus;
        if (isChildValidForProgressMeasure) {
            totalContentProgressWeight += PROGRESS_WEIGHT;
        }
    });
    return totalContentProgressWeight;
}
function getProgressWeightOfContent(content) {
    const contentType = content.offerType;
    switch (contentType) {
        case entity_1.ContentType.SECTION: {
            return getProgressWeightOfChildContent(content);
        }
        case entity_1.ContentType.LEARNING_CARD:
        case entity_1.ContentType.ASSIGNMENT_CARD:
        case entity_1.ContentType.PEER_REVIEW_CARD:
        case entity_1.ContentType.CARD_QUESTION:
        case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW: {
            return PROGRESS_WEIGHT;
        }
        default: {
            return PROGRESS_WEIGHT;
        }
    }
}
function checkIfChildValidForProgressMeasure(content, state) {
    let isChildValidForProgressMeasure = false;
    if (content.offerType === 'cardQuestion') {
        // CardQuestion children are valid for progressMeasure calculation only if they are actualSubmit
        isChildValidForProgressMeasure = content.contributeToCompleteStatus && state.actualSubmit;
    }
    else {
        isChildValidForProgressMeasure = content.contributeToCompleteStatus;
    }
    return isChildValidForProgressMeasure;
}
function updateProgressMeasureForNonLeafNode(state, user, content, allStates, resetProgressFlag = false) {
    const childrenStates = getState_1.getChildrenStatesForContentByUserId(allStates, content, user.userId);
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    let totalChildrenProgressMeasure = 0;
    let totalChildrenProgressWeight = 0;
    content.children.forEach((childContent) => {
        const childContentId = childContent._id;
        const childState = childrenStatesByContentId[childContentId];
        const isChildValidForProgressMeasure = checkIfChildValidForProgressMeasure(childContent, childState);
        if (isChildValidForProgressMeasure) {
            const progressWeight = getProgressWeightOfContent(childContent);
            const childProgressMeasure = (childState.scaledProgressMeasure || 0) * progressWeight;
            totalChildrenProgressMeasure += childProgressMeasure;
            totalChildrenProgressWeight += progressWeight;
        }
    });
    if (resetProgressFlag || state.contentType === 'assignmentCard') {
        state.progressMeasure = totalChildrenProgressWeight
            ? totalChildrenProgressMeasure / totalChildrenProgressWeight
            : 0;
    }
    else {
        state.progressMeasure = totalChildrenProgressWeight
            ? totalChildrenProgressMeasure / totalChildrenProgressWeight
            : 1;
    }
}
exports.updateProgressMeasureForNonLeafNode = updateProgressMeasureForNonLeafNode;
//# sourceMappingURL=updateProgressMeasureForNonLeafNode.js.map